import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { CustomViewService } from 'src/app/shared/services/custom-view.service';
import { WidgetsService } from 'src/app/shared/services/widgets.service';
import { WidgetInstanceModel } from '../../shared/models/widget.model';
import { InProgressApplicationsService } from './in-progress-applications.service';
import { InProgressApplicationRow } from './in-progress-application-row.model';

@Component({
  selector: 'app-in-progress-applications',
  templateUrl: './in-progress-applications.component.html',
  styleUrls: ['./in-progress-applications.component.scss'],
  standalone: false,
  providers: [InProgressApplicationsService]
})
export class InProgressApplicationsComponent implements OnInit, OnDestroy {
  @Input() widgetInfo: WidgetInstanceModel;

  subscriptions: Subscription[] = [];
  odataResult: InProgressApplicationRow[] = [];
  loaded = false;
  private _selectedView: CustomView;
  private _views: CustomView[] = [];
  itemPickerValues: ItemPickerModel[] = [];

  constructor(
    private inProgressApplicationsService: InProgressApplicationsService,
    private customViewService: CustomViewService,
    private widgetsService: WidgetsService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.customViewService.customViews
        .pipe(
          map((views) => {
            if (views) {
              return views.filter(
                (f) =>
                  f.viewContext == ViewContext.InProgressEntityCredentialApplications &&
                  !f.isTemporary
              );
            }
          })
        )
        .subscribe((views) => {
          if (views) {
            this._selectedView =
              views.find((x) => x.id == this.widgetInfo?.settings?.selectedViewId) ?? views[0];
            this._views = views;
            this.itemPickerValues = this._views.map((x) => new ItemPickerModel(x.id, null, x.name));
            this.inProgressApplicationsService.getRecentlyUpdatedApplications(this._selectedView);
          }
        }),
      this.inProgressApplicationsService.recentlyUpdatedApplications.subscribe((result) => {
        if (result) {
          this.odataResult = result;
          this.loaded = true;
        }
      })
    );
  }

  get selectedItemPickerValue(): ItemPickerModel {
    return this.itemPickerValues.find((x) => x.id == this._selectedView?.id);
  }

  itemPickerSelect(model: ItemPickerModel) {
    this._selectedView = this._views.find((x) => x.id == model.id);
    this.loaded = false;
    this.inProgressApplicationsService.getRecentlyUpdatedApplications(this._selectedView);
    this.widgetInfo.settings = {
      ...this.widgetInfo.settings,
      selectedViewId: this._selectedView.id
    };
    this.widgetsService.updateInstanceSettings(this.widgetInfo);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
